module.exports = new __parcel__URL__("MLMonsterMaker.ca6481c0.png").toString();